import { render } from "./post_to_account.vue?vue&type=template&id=9a8e4160"
import script from "./post_to_account.vue?vue&type=script&lang=js"
export * from "./post_to_account.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__